import React, { ReactNode } from 'react';

import Table from '../../components/table';
import type { RowData } from '../../components/table';

interface ManageUsersTableProps {
  data: RowData[];
  noRowsValue: ReactNode;
}

const ManageUsersTable: React.FC<ManageUsersTableProps> = ({ data, noRowsValue }) => {
  const headers = [
    { header: 'Username' },
    { header: 'Email Address' },
    { header: 'Status' },
    { header: 'Role' },
  ];
  
  // Apply masking to username and email columns
  const maskedData = data.map(row => ({
    ...row,
    values: row.values.map((value, index) => {
      // Mask username (index 0) and email (index 1)
      if (index === 0 || index === 1) {
        return <span data-fs-mask className="fs-mask">{value}</span>;
      }
      return value;
    }),
  }));
  
  return <Table headers={headers} data={maskedData} noRowsValue={noRowsValue} />;
};

export default ManageUsersTable;
